function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#A5A5A5;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M622.74,475.38c0.05-4.19-1.39-7.83-3.46-11.3c-1.69-2.83-4.52-2.36-7.17-2.23c-1.69,0.08-3.17,0.95-3.04,2.67 c0.49,6.88-4.14,6.17-8.58,6.17c-61.81-0.02-123.62,0-185.43,0c-88.13,0-176.26-0.01-264.4,0.01c-3.38,0-6.88,0.42-7.9-4.07 c0,0,0,0,0,0c-4.32,2-9.85,2.71-9.86,9.31c-0.01,11.22-0.06,22.44-0.1,33.66c0,0,0,0,0,0c1.42,1.15,3.13,0.96,4.78,0.96 c16.8,0.01,33.59,0.04,50.39,0.02c35.26-0.04,70.51-0.1,105.77-0.15c0,0,0,0,0,0c44.15,0.05,88.3,0.3,132.45,0.09 c63.29-0.3,126.59,1.02,189.87-0.8c6.48-0.19,6.65-0.23,6.66-6.83C622.73,493.7,622.64,484.54,622.74,475.38z M391.43,472.06 c-0.11-0.13-0.23-0.26-0.36-0.4c0.21,0,0.42,0,0.62,0c0,0,0,0,0,0C391.61,471.8,391.52,471.94,391.43,472.06z"
});

function SvgColourchangeRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 686.32 841.89",
    style: {
      enableBackground: "new 0 0 686.32 841.89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColourchangeRight);
export default __webpack_public_path__ + "static/media/colourchange-right.a672f0c7.svg";
export { ForwardRef as ReactComponent };